exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../containers/Popovers/Popovers.css"), undefined);

// module
exports.push([module.id, ".EKTV4FBajDD0Unt85cOKq {\n  min-width: 240px;\n  min-height: 120px;\n}\n\n._3GyCcnUIBSnkY2BeUk6lll {\n  margin: 11px 16px 12px;\n  height: 24px;\n}\n", ""]);

// exports
exports.locals = {
	"popover": "" + require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../containers/Popovers/Popovers.css").locals["popover"] + "",
	"sliderPopover": "EKTV4FBajDD0Unt85cOKq " + require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../containers/Popovers/Popovers.css").locals["popover"] + "",
	"sliderTitle": "_3GyCcnUIBSnkY2BeUk6lll"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/containers/Popovers/SliderPopover/SliderPopover.css
// module id = 3099
// module chunks = 23